import { type FC } from "react";

export interface IPlaybookScreenSectionProps {
  title?: string;
  description?: string;
  noPadding?: boolean;
}

const PlaybookScreenSection: FC<IPlaybookScreenSectionProps> = (props) => {
  return (
    <>
      {props.title && (
        <div className={"playbook-step-title"} style={props.noPadding && { padding: "0px" }}>
          {props.title}
        </div>
      )}
      {props.description && (
        <div className={"playbook-step-description"} style={props.noPadding && { padding: "0px" }}>
          {props.description}
        </div>
      )}
    </>
  );
};

export default PlaybookScreenSection;
